var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 184,
    viewBox: "0 0 210 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-17.813 74.8812L-29.302 115.782L164.551 167.724L176.162 125.911",
    fill: "#F8F5E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.813 74.8812L-29.302 115.782L164.551 167.724L176.162 125.911",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.0036 80.0045L-12.0376 120.407",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13879 82.1864L-3.67977 122.562",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.535 84.1682L3.71647 124.544",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.936 86.1514L11.1175 126.527",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3326 88.1332L18.5141 128.509",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2506 89.7189L24.432 130.094",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1733 91.3059L30.3548 131.681",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2673 92.8551L38.4925 133.862",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6521 95.1017L46.6574 136.135",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5969 97.0256L55.484 138.5",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7639 99.1146L63.6474 140.602",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1649 101.098L71.0484 142.585",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5615 103.08L78.445 144.567",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9625 105.063L85.846 146.55",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.88 106.649L91.764 148.136",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.799 108.234L97.6822 149.722",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.025 110.065L105.824 151.903",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.969 112.194L113.962 154.084",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.156 114.234L122.841 156.463",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.294 116.415L130.979 158.644",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.691 118.397L138.376 160.626",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.092 120.38L145.777 162.609",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.365 122.277L153.173 164.59",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.411 123.949L159.096 166.177",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 13.754L41.8483 19.3047",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.564 9.69055L37.1733 12.5333",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6874 150.829L94.6271 156.975",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3143 156.25C89.3687 160.111 89.3687 160.111 89.3687 160.111",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 112.948L122.604 111.56L116.267 135.209L121.448 136.597L127.785 112.948Z",
    fill: "black",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.403 118.726L147.222 117.338L140.879 141.009L146.06 142.397L152.403 118.726Z",
    fill: "black",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.118 124.277L167.937 122.889L161.595 146.56L166.776 147.948L173.118 124.277Z",
    fill: "black",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.588 106.977L100.411 105.59L94.0686 129.261L99.2453 130.648L105.588 106.977Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6739 102.167L79.4928 100.779L73.1501 124.45L78.3312 125.839L84.6739 102.167Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2558 95.6246L55.0791 94.2375L48.7364 117.909L53.9132 119.296L60.2558 95.6246Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8998 90.2822L32.7188 88.8939L26.5381 111.961L31.7191 113.349L37.8998 90.2822Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 84.8627L11.9678 83.4756L5.62512 107.147L10.8018 108.534L17.1445 84.8627Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8998 90.2822L32.7188 88.8939L26.5381 111.961L31.7191 113.349L37.8998 90.2822Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2558 95.6246L55.0791 94.2375L48.7364 117.909L53.9132 119.296L60.2558 95.6246Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6739 102.167L79.4928 100.779L73.1501 124.45L78.3312 125.839L84.6739 102.167Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M105.588 106.977L100.411 105.59L94.0686 129.261L99.2453 130.648L105.588 106.977Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 84.8627L11.9678 83.4756L5.62512 107.147L10.8018 108.534L17.1445 84.8627Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M183.143 155.871C181.709 161.54 177.212 165.612 171.874 166.787L182.406 127.111L179.263 126.094L-24.0641 72.402L-33.5854 109.772C-35.9753 106.299 -36.8903 101.841 -35.7128 97.4462L-16.0417 24.0327C-13.9255 16.135 -5.83919 11.4117 2.08168 13.449L191.513 62.1405C199.469 64.1872 204.273 72.2793 202.262 80.243L183.143 155.871Z",
    fill: "#37507C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.874 166.787C177.212 165.612 181.709 161.54 183.143 155.871L202.262 80.243C204.273 72.2793 199.469 64.1872 191.513 62.1405L2.08168 13.449C-5.83919 11.4117 -13.9255 16.135 -16.0417 24.0327L-35.7128 97.4462C-36.8903 101.841 -35.9753 106.299 -33.5854 109.772L-24.0641 72.402L179.263 126.094L182.406 127.111L171.874 166.787Z",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M171.874 166.787L164.551 167.724",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9844 74.568L118.913 90.8937C118.913 90.8937 126.743 96.1648 121.063 102.569L49.7948 83.4723C49.7948 83.4723 48.6572 76.826 57.9844 74.568Z",
    fill: "#879ECF",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5204 71.4164L33.7774 73.6288L31.8698 81.8426L23.3392 79.5568L25.5204 71.4164Z",
    fill: "#984352",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80457 65.8655L13.0617 68.078L11.1541 76.2917L2.62335 74.0059L4.80457 65.8655Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M157.816 104.491L166.073 106.703L164.166 114.913L155.636 112.627L157.816 104.491Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M176.312 109.447L184.569 111.659L182.662 119.868L174.131 117.583L176.312 109.447Z",
    fill: "#984352",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M138.579 99.3363L146.836 101.549L144.93 109.758L136.399 107.472L138.579 99.3363Z",
    fill: "#FCD700",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1494 50.135C86.7849 50.5732 88.3324 50.1008 88.606 49.0798C88.8796 48.0588 87.7756 46.8759 86.1401 46.4376C84.5047 45.9994 82.9571 46.4719 82.6835 47.4929C82.4099 48.5139 83.514 49.6968 85.1494 50.135Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0054 73.0648C80.6408 73.503 82.1884 73.0306 82.4619 72.0096C82.7355 70.9886 81.6315 69.8057 79.9961 69.3674C78.3606 68.9292 76.813 69.4017 76.5394 70.4227C76.2659 71.4437 77.3699 72.6266 79.0054 73.0648Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1774 61.227C83.8128 61.6652 85.3604 61.1928 85.6339 60.1718C85.9075 59.1508 84.8035 57.9679 83.1681 57.5297C81.5326 57.0915 79.985 57.5639 79.7114 58.5849C79.4379 59.6059 80.5419 60.7888 82.1774 61.227Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M147.499 66.0467C149.134 66.485 150.682 66.0125 150.955 64.9915C151.229 63.9705 150.125 62.7876 148.49 62.3494C146.854 61.9111 145.307 62.3836 145.033 63.4046C144.759 64.4256 145.863 65.6085 147.499 66.0467Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141.355 88.9767C142.99 89.4149 144.538 88.9424 144.811 87.9214C145.085 86.9004 143.981 85.7175 142.346 85.2793C140.71 84.8411 139.163 85.3135 138.889 86.3345C138.615 87.3555 139.719 88.5385 141.355 88.9767Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M144.526 77.1435C146.161 77.5818 147.709 77.1093 147.982 76.0883C148.256 75.0673 147.152 73.8844 145.516 73.4462C143.881 73.008 142.333 73.4804 142.06 74.5014C141.786 75.5224 142.89 76.7053 144.526 77.1435Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M172.654 72.7872C174.29 73.2254 175.837 72.753 176.111 71.732C176.384 70.711 175.28 69.5281 173.645 69.0898C172.009 68.6516 170.462 69.1241 170.188 70.1451C169.915 71.1661 171.019 72.349 172.654 72.7872Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.51 95.7171C168.146 96.1554 169.693 95.6829 169.967 94.6619C170.24 93.6409 169.136 92.458 167.501 92.0198C165.865 91.5816 164.318 92.054 164.044 93.075C163.771 94.096 164.875 95.2789 166.51 95.7171Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M169.681 83.8838C171.316 84.322 172.864 83.8495 173.137 82.8285C173.411 81.8075 172.307 80.6246 170.671 80.1864C169.036 79.7482 167.488 80.2206 167.215 81.2416C166.941 82.2626 168.045 83.4456 169.681 83.8838Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M120.323 57.9707C121.958 58.4089 123.506 57.9365 123.779 56.9155C124.053 55.8945 122.949 54.7115 121.313 54.2733C119.678 53.8351 118.13 54.3075 117.857 55.3285C117.583 56.3495 118.687 57.5324 120.323 57.9707Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M114.178 80.9049C115.813 81.3431 117.361 80.8707 117.634 79.8497C117.908 78.8287 116.804 77.6457 115.168 77.2075C113.533 76.7693 111.985 77.2417 111.712 78.2627C111.438 79.2837 112.542 80.4667 114.178 80.9049Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M117.349 69.067C118.985 69.5052 120.532 69.0328 120.806 68.0118C121.08 66.9908 119.975 65.8078 118.34 65.3696C116.705 64.9314 115.157 65.4039 114.883 66.4249C114.61 67.4459 115.714 68.6288 117.349 69.067Z",
    fill: "#D78E6D",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9845 74.5681L55.2098 84.9234",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5531 75.2563L57.7784 85.6116",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8036 75.8595L60.0289 86.2148",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M65.297 76.5275L62.5223 86.8827",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7862 87.4893L67.5609 77.134",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8204 77.7395L67.0458 88.0948",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3933 78.4288L69.6186 88.7841",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M74.644 79.032L71.8694 89.3872",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1329 79.6989L74.3583 90.0541",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6269 90.6619L79.4016 80.3066",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6611 80.9122L78.8864 91.2675",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2297 81.6003L81.4551 91.9556",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4802 82.2035L83.7055 92.5588",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9739 82.8716L86.1992 93.2268",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M88.463 93.8335L91.2377 83.4783",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4973 84.0837L90.7226 94.439",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0703 84.7732L93.2956 95.1285",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3209 85.3762L95.5462 95.7315",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M100.81 86.043L98.0353 96.3982",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M100.303 97.006L103.078 86.6508",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M105.338 87.2563L102.563 97.6116",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M107.906 87.9446L105.132 98.2998",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M110.157 88.5476L107.382 98.9029",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M112.651 89.2158L109.876 99.5711",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M112.14 100.178L114.914 89.8224",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M116.875 101.446L119.551 91.4618",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.399 100.783L117.174 90.4279",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9788 57.0761L50.7424 63.113L-4.28118 48.3695L-1.77197 42.9416L-1.76756 42.9427L50.9788 57.0761Z",
    fill: "#879ECF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2045 51.3437L50.9787 57.0761L-1.7676 42.9428L-1.77202 42.9416L0.777313 37.4346L51.2001 51.3425L51.2045 51.3437Z",
    fill: "#879ECF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4466 45.0906L51.1999 51.3423L0.777173 37.4344L3.215 32.167L51.4466 45.0906Z",
    fill: "#879ECF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6919 38.7912L51.4466 45.0906L3.21499 32.167L5.83453 26.5038L51.6919 38.7912Z",
    fill: "#879ECF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2046 51.3436L50.9788 57.076L50.7424 63.113L-4.28113 48.3694L-1.77192 42.9415L0.777413 37.4344L3.21524 32.1671L5.83478 26.5038L51.6921 38.7913L51.4469 45.0907L51.2002 51.3424",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21509 32.1671L51.4467 45.0907",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0.7771 37.4346L51.1999 51.3425L51.2043 51.3437",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.76782 42.9426L50.9785 57.076",
    stroke: "#58453E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.d32901307d457281ef2afcbfe0911951.svg";
export { ForwardRef as ReactComponent };